import "../App.css";
import PostHorizontal from "../components/PostHorizontal";
import SmiHorizontal from "../components/SmiHorizontal";
import Authors from "../components/Authors";
import CitiesTable from "../components/CitiesTable";
import StopSourcesList from "../components/StopSourcesList";
import { useAppDispatch } from "../redux/store/hooks";
import {
  resetFeedFilter,
  setProduct,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";
import Calendar from "../components/Calendar";
import { Button } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getMainProduct,
  getPostIsLoading,
  getProduct,
  getProducts,
  getReferences,
} from "../redux/selectors";

function Sources() {
  const dispatch = useAppDispatch();
  //dispatch(resetFeedFilter());
  const [loading, setLoading] = useState(true);
  const mainProduct = useSelector(getMainProduct);
  const products = useSelector(getProducts);
  const product = useSelector(getProduct);
  const [competitors, setCompetitors] = useState([]);
  const references = useSelector(getReferences);

  useEffect(() => {
    if (products.length > 0 && mainProduct.id) {
      setLoading(true);
      let compArr: any = [];
      compArr = [
        ...products?.find((it: any) => it.id == mainProduct?.id)?.competitor,
      ];
      console.log(compArr);
      setCompetitors(compArr);
      setLoading(false);
    }
  }, [products, mainProduct]);

  return (
    <div className="App">
      <h1>Источники</h1>
      <Calendar />
      <div className="btn-group">
        <Button
          type={references == mainProduct?.client?.id ? "primary" : "default"}
          onClick={() => {
            dispatch(setReferences([mainProduct?.client?.id]));
            dispatch(setReferencesFilter([mainProduct?.client?.id]));
            dispatch(setProduct(mainProduct?.id));
          }}
        >
          {mainProduct?.client?.title}
        </Button>
        {competitors
          ?.sort((a: any, b: any) => a.title.localeCompare(b.title))
          ?.map((competitor: any, id) => (
            <Button
              key={id}
              type={references == competitor?.id ? "primary" : "default"}
              onClick={() => {
                dispatch(setReferences([competitor?.id]));
                dispatch(setReferencesFilter([competitor?.id]));
                dispatch(
                  setProduct(
                    products.find((it: any) => it?.client?.id == competitor?.id)
                      ?.id
                  )
                );
              }}
            >
              {competitor?.title}
            </Button>
          ))}
      </div>
      <Authors />
      <div className="grid2 main-block">
        <PostHorizontal />
        <SmiHorizontal />
        {/*<ThemesHorizontal />*/}
      </div>
      <CitiesTable />
      <StopSourcesList />
    </div>
  );
}

export default Sources;
